import { request } from '@/shared/api/request'

export const sendXml = (data) =>
    request({ url: `contract/persCard/employee/sendXml`, method: 'POST', data })
